module.exports = __webpack_public_path__ + "static/img/wangtong.cf7e739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangtong.png
// module id = 5qRN
// module chunks = 1